import styles from './fitmentSection.module.scss'

import React from 'react'

import { useVehicleStore } from 'Clutch/Stores/VehicleStore'
import ErrorBoundary from 'Clutch/UtilityComponents/ErrorBoundary'

import Divider from 'Clutch/Atoms/Divider'
import Svg from 'Clutch/Atoms/Svg'
import Typography from 'Clutch/Atoms/Typography'

const FitmentSection = ({
  doesFit,
  hasAddonEngine,
  mainDisplayName,
  engineAddonDisplayName,
  projectId,
  hideFitmentDrawer,
}) => {
  const selectCustomerProject = useVehicleStore((x) => x.selectCustomerProject)

  const handleOnClick = () => {
    if (projectId) {
      selectCustomerProject(projectId)
      hideFitmentDrawer()
    }
  }

  return (
    <ErrorBoundary>
      <div className={styles.fitment} onClick={handleOnClick}>
        <div className={styles.fitment_text}>
          <Typography size={1} inline>
            {doesFit ? 'Fits your' : 'May not fit your'}
          </Typography>
          <Typography size={1} inline font={'bold'} className={styles.fitment_vehicle_text}>
            {mainDisplayName}
          </Typography>
          {hasAddonEngine && (
            <>
              <Typography size={1} inline className={styles.fitment_vehicle_text}>
                {' with a '}
              </Typography>
              <Typography size={1} inline font={'bold'} className={styles.fitment_vehicle_text}>
                {engineAddonDisplayName}
              </Typography>
            </>
          )}
        </div>
        <Svg
          icon={doesFit ? 'check' : 'warning'}
          intent={doesFit ? 'positive' : 'negative'}
          size={1.25}
          className={styles.fitment_svg}
        />
      </div>
      <Divider />
    </ErrorBoundary>
  )
}

export default FitmentSection
